import { dataFetchedReducerFactory } from './dataFetched'

const noop = x => x

export const GRAPHQL_DATA_ADDED = 'GRAPHQL/DATA_ADDED'

export function dataAdded(payload, meta) {
  return {
    type: GRAPHQL_DATA_ADDED,
    payload,
    meta: {
      graphql: meta,
    },
  }
}

export function dataAddedReducerFactory({
  refBuilder,
  entityMergers,
  defaultEntityMerger,
  extraAddReducer,
}) {
  const dataFetchedReducer = dataFetchedReducerFactory({
    refBuilder,
    entityMergers,
    defaultEntityMerger,
  })

  return function addEntityReducer(state, payload) {
    const { __typename } = payload
    const extraReducer = extraAddReducer[__typename] || noop
    return extraReducer(dataFetchedReducer(state, payload), payload)
  }
}
